import React from "react";

const CallButton = () => {
  return (
    <div className="call-button" style={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <a
        className="contact-link call"
        target="_blank"
        rel="noopener noreferrer"
        href="https://conciergewellness.janeapp.com/"
      >
        Book FREE Discovery Call!
      </a>
    </div>
  );
};

export default CallButton;
